import DOMPurify from 'dompurify';

/**
 * Sanitiza el HTML del editor permitiendo solo ciertos tags y atributos
 */
export const sanitizeHtml = (html: string): string =>
  DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['br', 'p', 'ul', 'ol', 'li'],
    ALLOWED_ATTR: ['data-list'],
  });

/**
 * Convierte HTML sanitizado a texto plano (formato email)
 */
export const convertHtmlToPlainText = (html: string): string => {
  let olIndex = 1;

  return html
    .replace(/<p[^>]*>/gi, '')
    .replace(/<\/p>\s*<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/\r\n/g, '\n')
    .replace(/\n{3,}/g, '\n')
    .replace(/<ul[^>]*>/gi, '')
    .replace(/<\/ul>/gi, '')
    .replace(/<ol[^>]*>/gi, () => {
      olIndex = 1;
      return '';
    })
    .replace(/<\/ol>/gi, '')
    .replace(/<li([^>]*)>/gi, (attrs) => {
      const isOrdered = /data-list="ordered"/i.test(attrs);
      const isBullet = /data-list="bullet"/i.test(attrs);

      if (isOrdered) {
        const number = olIndex;
        olIndex += 1;
        return `${number}. `;
      }

      if (isBullet) return '• ';
      return '';
    })
    .replace(/<\/li>/gi, '\n')
    .trim();
};
